import { render, staticRenderFns } from "./Operational.Report.Imp.Channel.vue?vue&type=template&id=039413f4&scoped=true"
import script from "./Operational.Report.Imp.Channel.vue?vue&type=script&lang=js"
export * from "./Operational.Report.Imp.Channel.vue?vue&type=script&lang=js"
import style0 from "./Operational.Report.Imp.Channel.vue?vue&type=style&index=0&id=039413f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039413f4",
  null
  
)

export default component.exports